export { default as SVGContentLoader } from 'react-content-loader';

export { ContentLoader } from './ContentLoader';
export { RectContentLoader } from './RectContentLoader';
